const PasswordValidator = (UserService) => {
  'ngInject'

  const require = 'ngModel'

  const link = (scope, element, attrs, ctrl) => {
    ctrl.$asyncValidators.checkPassword = (modelValue, viewValue) => UserService.checkPassword(modelValue)
  }

  return { require, link }
}

export default PasswordValidator



// WEBPACK FOOTER //
// ./src/app/common/validators/password.validator.js